import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { Provider } from "./provider.tsx";
import "@/styles/globals.css";
import { PostHogProvider } from 'posthog-js/react';
import * as Sentry from "@sentry/react";
import { isDevEnv } from "./utils/devEnv.ts";
import './utils/i18n';
import { isMobile } from "./stores/MenuStore.ts";

if (!isDevEnv())
  Sentry.init({
    dsn: "https://364daab6dc01713f314be4f002e369e3@o4508700977397760.ingest.us.sentry.io/4508700980281344",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

const posthogOptions = {
  api_host: isDevEnv() ? '#' : 'https://e.craquestats.com.br',
  autocapture: false,
  capture_performance: {
    web_vitals_allowed_metrics: []
  },
  capture_pageleave: false,
  capture_pageview: true,
  enable_heatmaps: false,
  disable_session_recording: true,
}


ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <PostHogProvider
      apiKey={'phc_faeGpqiDiuSNikdNekCBfEW5q7zRWhTaLeOj9Y6WiT2'}
      options={posthogOptions}
    >
      <Provider>
        <main className={`text-foreground bg-background ${isMobile() ? 'mobile' : 'desktop'}`} style={{ minHeight: '100vh' }}>
          <App />
        </main>
      </Provider>
    </PostHogProvider>
  </BrowserRouter>,
);
